import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class NavigationTrackerService {
    private previousUrl: string;
    private currentUrl: string;

    private history = [];
  

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;
        this.add(event.urlAfterRedirects);
      }
    });
  }

    public getPreviousUrl(): string {
        return this.previousUrl;
    }
  
    add(url) {
        this.history.push(url);
        if (this.history.length > 100) {
            this.history.shift(); 
        }
    }

    getItems() {
        return this.history;
    }

    public getPreviousCiListSearch(): string{
        const regex = /^\/search$|^\/projects\/[A-Za-z0-9-]+\/items(?:\?.*)?$/i;


        for (let i = this.history.length - 1; i >= 0; i--) {
            if (regex.test(this.history[i])) {
            return this.history[i];
            }
        }

        return "/";
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/navigation-tracker.service.ts